import { render, staticRenderFns } from "./_agentTaskStats.vue?vue&type=template&id=61c980ca&scoped=true"
import script from "./_agentTaskStats.vue?vue&type=script&lang=js"
export * from "./_agentTaskStats.vue?vue&type=script&lang=js"
import style0 from "./_agentTaskStats.vue?vue&type=style&index=0&id=61c980ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c980ca",
  null
  
)

export default component.exports